import ReactDOM from 'react-dom';
import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import { useDragLayer } from 'react-dnd';

import useDragOffsetDiff from '../../../hooks/useDragOffsetDiff';
import { addDragItems, clearDragItems } from '../../../actions';

let lockCustomDragLayer = false;
function CustomDragLayer({ layer, items = [] }) {
  const layerStyles = (isDragging, clientOffset) => ({
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 2000,
    left: (isDragging && clientOffset) ? clientOffset.x : 0,
    top: (isDragging && clientOffset) ? clientOffset.y : 0,
    height: isDragging ? '100%' : 0,
  })

  const getStyle = (clientOffset, dragOffsetDiff) => {
    if (!dragOffsetDiff || !clientOffset) {
      return { display: 'none' }
    }
    const x = dragOffsetDiff.x + 20;
    const y = dragOffsetDiff.y - 10;
    const transform = `translate(${x}px, ${y}px)`;
    return {
      transform,
      WebkitTransform: transform,
    }
  }

  const {
    isDragging,
    clientOffset,
    itemType
  } = useDragLayer((monitor) => ({
    clientOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
    itemType: monitor.getItemType()
  }))

  const dragOffsetDiff = useDragOffsetDiff(isDragging);

  const [base, setBase] = useState(null);
  useEffect(() => {
    if (!lockCustomDragLayer && isDragging) {
      if (clientOffset) {
        setBase({x: clientOffset.x / window[`window_zoom`] , y: clientOffset.y / window[`window_zoom`]});
        lockCustomDragLayer = true;
      }
    } else if (lockCustomDragLayer && !isDragging) {
      setBase(null);
      lockCustomDragLayer = false;
    }
  }, [isDragging, clientOffset])

  const show = (itemType !== 'PLAYLIST-MENU');
  const element = document.getElementById(layer);

  const Portal = ({element}) => {
    return ReactDOM.createPortal((
      <div style={layerStyles(isDragging, base)}>
        <div style={getStyle(base, dragOffsetDiff)}>
          <span style={{display: "inline-block"}} className={`tag`}>
            {(items.length > 0) ? items.length : <i className={`fa fa-spinner`} /> }
          </span>
        </div>
      </div>),
    element);
  }

  const dispatch = useDispatch();
  useEffect(() => {
    if (show && element && isDragging) {
      dispatch(addDragItems());      
      const el = document.getElementById('lmc');
      if (el) { el.classList.add("isDrag"); }
    } else {
      dispatch(clearDragItems());
      const el = document.getElementById('lmc');
      if (el) { el.classList.remove("isDrag"); }
    }
  }, [show, element, isDragging, dispatch])


  return (show && element) ? <Portal element={element} /> : null

}

CustomDragLayer.propTypes = {
  layer: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
}

export default CustomDragLayer;
